(function($) {
	// Helper function to validate CSS selector
	function isValidCSSSelector(selector) {
		try {
			// Check if it's a valid CSS selector by attempting to query it
			$(selector);
			return true;
		} catch (e) {
			return false;
		}
	}

	// Helper function to safely get element offset
	function getSafeOffset(selector) {
		try {
			var $element = $(selector);
			return $element.length > 0 ? $element.offset().top : 0;
		} catch (e) {
			console.warn('Invalid CSS selector:', selector);
			return 0;
		}
	}

	//same page
	$("a[href*=\\#]").on("click", function(event) {
		if (this.pathname === window.location.pathname) {
			var hash = $(this).prop("hash");
			/* Add Extra Check */
			if(hash && isValidCSSSelector(hash)){
				event.preventDefault();
				var targetOffset = getSafeOffset(hash) - $("#masthead").height();
				$("body, html").scrollTop(targetOffset);
			}
		}
	});
	//external link
	if (window.location.hash) {
		var hash = window.location.hash;
		$(document).ready(function() {
			if (isValidCSSSelector(hash)) {
				var targetOffset = getSafeOffset(hash) - $("#masthead").height();
				$("body, html").scrollTop(targetOffset);
			}
		});
	}
	//tabs page
	$(document).ready(function () {
      var url = window.location.href;
      if(url.indexOf("tab") > -1) {
				$('html, body').animate({
		        scrollTop: $('.block-top-50-tabs').offset().top
		    }, 0);
      }
  });
})(jQuery);
